import { useEffect, useState } from "react";

// single source of truth for portrait vs landscape - matchMedia stays in
// sync with the actual CSS orientation query, so this can't drift from
// what the browser itself thinks the viewport is
const QUERY = "(orientation: portrait)";

const getIsPortrait = () =>
  typeof window !== "undefined" && window.matchMedia
    ? window.matchMedia(QUERY).matches
    : false;

export default function useOrientation() {
  const [isPortrait, setIsPortrait] = useState(getIsPortrait);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mql = window.matchMedia(QUERY);
    const onChange = (event) => setIsPortrait(event.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isPortrait;
}
